import { FeeSettingsProvider } from '../FeeSettingsProvider';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class FeeSettingsFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/fee-settings`, headers);
  }

  public createFeeSettings(token: string): FeeSettingsProvider {
    return new FeeSettingsProvider(this.apiClientFactory.createAuthorizedClient(token));
  }
}
